// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__GBeiz","multiselectDiv":"Modal_multiselectDiv__nHFv3"};